import { forwardRef, ReactNode } from 'react';
import { IconName } from '@optimus-web/icons';
import { Icon } from '../Icon';
import { ensureString } from '../utils';
import { TagContainer, TagText } from './style';
import { TagVariant } from './types';

export interface TagProps {
    variant?: TagVariant;
    outline?: boolean;
    leadingIcon?: IconName;
    trailingIcon?: IconName;
    children?: ReactNode;
    ref?: React.Ref<HTMLDivElement>;
}

export const Tag = forwardRef<HTMLDivElement, TagProps>(
    ({ variant = 'basicBold', outline = false, leadingIcon, trailingIcon, children, ...other }: TagProps, ref) => {
        // Set appropriate a11y attributes based on whether aria-hidden is explicitly provided
        const a11yProps =
            'aria-hidden' in other
                ? { role: 'presentation' }
                : { role: 'status', title: ensureString({ value: children }) || leadingIcon || trailingIcon };

        return (
            <TagContainer
                variant={variant}
                outline={outline}
                data-test-tag
                data-test-tag-variant={variant}
                {...other}
                ref={ref}
                {...a11yProps}
            >
                {leadingIcon ? <Icon size="small" value={leadingIcon} {...other} /> : null}
                <TagText>{children}</TagText>
                {trailingIcon ? <Icon size="small" value={trailingIcon} {...other} /> : null}
            </TagContainer>
        );
    }
);
